export function stringToHtmlID(string: string | null | undefined) {
  if (string === null || string === undefined) {
    return undefined;
  }
  // Turns string into readable id example
  return string
    .toLocaleLowerCase()
    .replace(/^#+ /g, '')
    .replace(/\s+/g, '-')
    .replace(/ä/, 'ae')
    .replace(/ü/, 'ue')
    .replace(/ö/, 'oe')
    .replace(/&/g, '__AND__') // We want to keep the & in the id
    .replace(/\W/g, '-')
    .replace(/__AND__/g, '&')
    .replace(/^-+/g, '')
    .replace(/-+$/g, '')
    .replace(/--/g, '-')
    .substring(0, 64);
}
